import React from 'react'
import Liberyus from '../../components/general/liberyus'
import Explore from '../home/explore'
import SoftwareLibecms from './software-libecms'
import SoftwareBanner from './software-banner'
import SoftwareItems from './software-items'

const SoftwarePage = () => {
    return (
        <Liberyus>
            <div className='services-page'>
                <SoftwareBanner />
                <Explore />
                <SoftwareLibecms />
                <SoftwareItems />
            </div>
        </Liberyus>
    )
}

export default SoftwarePage
